import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const DiscussionTabContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 5px;

  ${({ isDarkMode, theme }) => {
    if (isDarkMode) return;
    const targetColor = theme.tabs.backgroundActive;
    return css`
      /* backup background for lack of linear-gradient support */
      background: ${targetColor};
      background: linear-gradient(180deg, ${targetColor} 0%, ${colors.fsLightBlue} 15%, ${colors.fsLightBlue} 100%);
    `;
  }}
`;
